import Class from './c-modal';
import './c-modal@';

import ModalHideEvent from './modal-hide-event';

export default Class;
export { ModalHideEvent };